import { OutlineButton, TextButton } from '../../Buttons/styled';
import { StyledFooter } from '../MinMaxFilter/styled';

type Props = {
  isDisabled: boolean;
  handleCloseFilter: () => void;
  handleApplyFilter: () => void;
};

export const FilterFooter = ({ isDisabled, handleApplyFilter, handleCloseFilter }: Props): JSX.Element => {
  return (
    <StyledFooter>
      <TextButton onClick={handleCloseFilter}>Cancel</TextButton>
      <OutlineButton data-testid="applyButton" onClick={handleApplyFilter} disabled={isDisabled}>
        Apply
      </OutlineButton>
    </StyledFooter>
  );
};
